<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.id') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.orderNumber }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.currency') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.currency }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.lang') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.lang }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.purpose') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.purpose }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.created-at') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.createdAt }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.exp-at') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.expireAt }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <hide-by-access action="read" data="bills-recipient_info_hide">
          <div class="transaction-item-info__title">
            {{ $t('operation-information.bill-info.account') }}
          </div>
          <div class="transaction-item-info__value">
            {{ transaction.billInfo.email }}
            <br />
            {{ transaction.billInfo.phone }}
          </div>
        </hide-by-access>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.comment') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.comment }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.sum') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.billInfo.amount }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.bill-info.link') }}
        </div>
        <div
          class="transaction-item-info__value transaction-item-info__value--bill-link"
          @click="goToBillPage"
        >
          🔗
          {{ transaction.billInfo.link }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'
import HideByAccess from '@vue-app/components/base/role-based/HideByAccess.vue'

export default {
  name: 'TransactionItemBillInfo',
  components: { HideByAccess },
  props: {
    transaction: {
      type: Transaction,
    },
  },
  methods: {
    goToBillPage() {
      if (this.transaction.billInfo.link.trim().length > 0) {
        window.open(this.transaction.billInfo.link, '_blank')
      }
    },
  },
}
</script>

<style lang="scss">
.transaction-item-info__value--bill-link {
  color: #64748B;
  opacity: 0.7;
  cursor: pointer;
}
</style>
